/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-card-consent[_ngcontent-%COMP%]{background:#fff;border-bottom:1px solid #979797}.nsc-card-consent[_ngcontent-%COMP%]     .mat-icon{font-size:36px;height:36px;width:36px;position:relative;top:3px}.nsc-card-consent[_ngcontent-%COMP%]     .mat-button{color:#396fae}"];
export { styles as styles };
